import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { styled } from '@noshiro/goober';
import { memoNamed } from '@noshiro/preact-utils';
import { push, redirect, usePathname } from '@noshiro/tiny-router-preact-hooks';
import Markdown from 'preact-markdown';
import { useEffect, useMemo } from 'preact/hooks';
import { Profile2Md, ProfileMd, SkillsMd } from './assets';
import { GithubIconLink, LastUpdated, MuiAppBar, MuiTabs, Products, TwitterIconLink, Writings, } from './components';
import { labelList, links, routeList, routes } from './constants';
const pathNameLastToIndex = (pathNameLast) => {
    // eslint-disable-next-line unicorn/prefer-array-index-of
    const res = routeList.findIndex((e) => e === `/${pathNameLast}/`);
    return res === -1 ? undefined : res;
};
const tabIndexOnChange = (tabIdx) => {
    if (IList.indexIsInRange(routeList, tabIdx)) {
        const route = routeList[tabIdx];
        if (route !== undefined) {
            push(route);
        }
    }
};
export const Main = memoNamed('Main', () => {
    const pathname = usePathname();
    const pathNameLast = useMemo(() => { var _a; return (_a = IList.last(pathname.split('/').filter((s) => s !== ''))) !== null && _a !== void 0 ? _a : ''; }, [pathname]);
    // pathnameと対応させるため、routerを使ってタブ切り替えを制御
    const tabIndex = useMemo(
    //
    () => pathNameLastToIndex(pathNameLast), [pathNameLast]);
    useEffect(() => {
        if (tabIndex === undefined) {
            redirect(routes.profile);
        }
    }, [pathname, tabIndex]);
    return (_jsxs(Root, { children: [_jsxs(AppBarFlex, { children: [_jsx(MuiTabs, { labels: labelList, scrollable: true, tabIndex: tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0, tabIndexChange: tabIndexOnChange }), _jsxs(IconButtons, { children: [_jsx(IconButton, Object.assign({ title: links.twitter }, { children: _jsx(TwitterIconLink, {}) })), _jsx(IconButton, Object.assign({ title: links.github }, { children: _jsx(GithubIconLink, {}) }))] })] }), _jsx(LastUpdatedWrapper, { children: _jsx(LastUpdated, {}) }), _jsx(ContentWrapper, { children: match(pathname, {
                    [routes.profile]: Markdown(ProfileMd),
                    [routes.profile2]: Markdown(Profile2Md),
                    [routes.skills]: Markdown(SkillsMd),
                    [routes.products]: _jsx(Products, {}),
                    [routes.writings]: _jsx(Writings, {}),
                }) })] }));
});
const Root = styled('div') `
  min-height: 100vh;
`;
const LastUpdatedWrapper = styled('div') `
  padding: 10px 15px 0 0;
  display: flex;
  justify-content: flex-end;
`;
const ContentWrapper = styled('div') `
  padding: 0 20px 20px 20px;

  overflow: auto;
`;
const AppBarFlex = styled(MuiAppBar) `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const IconButtons = styled('div') `
  display: flex;
  margin-right: 20px;
`;
const IconButton = styled('div') `
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 8px;
`;
